import { render } from "./VenueForm.vue?vue&type=template&id=271939f2"
import script from "./VenueForm.vue?vue&type=script&lang=js"
export * from "./VenueForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__